<template>
  <section id="help-section" class="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
    <div class="flex items-center space-x-3 mb-4">
      <span class="material-symbols-outlined text-brand-blue text-xl">help</span>
      <h4 class="font-bold text-gray-900">Need Help?</h4>
    </div>
    <p class="text-sm text-gray-600 mb-4">Our support team is here to help you set up your teaching profile</p>
    <a
      href="mailto:management@bindle.co.uk"
      class="w-full bg-gray-100 text-gray-900 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors flex items-center justify-center"
    >
      <span class="material-symbols-outlined mr-2">alternate_email</span>
      Email Support
    </a>
  </section>
</template>
